import { addDoc, collection, getDocs, orderBy, query, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import type { CreateSupplierInput, Supplier } from '../types/supplier';

const COLLECTION_NAME = 'suppliers';

const text = (value: unknown, field: string, required = false): string | null => {
  const normalized = String(value || '').trim();
  if (required && !normalized) throw new Error(`${field} là bắt buộc`);
  return normalized || null;
};

export const normalizeSupplierInput = (input: CreateSupplierInput) => ({
  code: text(input.code, 'Mã nhà cung cấp', true) as string,
  name: text(input.name, 'Tên nhà cung cấp', true) as string,
  phone: text(input.phone, 'Số điện thoại'),
  address: text(input.address, 'Địa chỉ'),
  note: text(input.note, 'Ghi chú'),
});

const toDate = (value: unknown): Date => value instanceof Timestamp ? value.toDate() : new Date();

export const supplierService = {
  async getActiveSuppliers(): Promise<Supplier[]> {
    const snapshot = await getDocs(query(collection(db, COLLECTION_NAME), orderBy('name')));
    return snapshot.docs.map((item) => {
      const raw = item.data();
      return {
        id: item.id,
        code: String(raw.code || '').trim(),
        name: String(raw.name || '').trim(),
        phone: text(raw.phone, 'Số điện thoại'),
        address: text(raw.address, 'Địa chỉ'),
        note: text(raw.note, 'Ghi chú'),
        isActive: raw.isActive !== false,
        createdAt: toDate(raw.createdAt),
        updatedAt: toDate(raw.updatedAt),
      };
    }).filter((supplier) => supplier.isActive && supplier.code && supplier.name);
  },

  async createSupplier(input: CreateSupplierInput): Promise<Supplier> {
    const normalized = normalizeSupplierInput(input);
    const now = Timestamp.fromDate(new Date());
    const ref = await addDoc(collection(db, COLLECTION_NAME), {
      ...normalized,
      isActive: true,
      createdAt: now,
      updatedAt: now,
    });
    return { id: ref.id, ...normalized, isActive: true, createdAt: now.toDate(), updatedAt: now.toDate() };
  },
};
